import _ from 'lodash'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { message } from 'antd'

import FileUploader from '~/core/FileUploader'
import Box from '~/core/Box'
import { uploadFile } from '~/lib/uploadFile'
import { isBlockedFileName } from '~/lib/fileExtensions'

import { createErpAttachment } from './logic'

const UPLOADER_PLACEMENT = 'project-uploader'

class UploadMessageAttachment extends PureComponent {
    createEntity = async file => {
        if (isBlockedFileName(file.name)) {
            return
        }

        const { dispatch, sendButtonDisabled } = this.props

        sendButtonDisabled(true)
        if (typeof dispatch !== 'function') {
            return null
        }

        const erpAttachment = await dispatch(
            createErpAttachment({
                file,
            }),
        )

        _.assign(file, {
            erpAttachmentId: erpAttachment.erpId,
            uploadUrl: erpAttachment.putUrl,
        })

        return file
    }

    uploadEntity = (...args) => {
        const [file, { onProgress, onSuccess, onError }] = args

        if (isBlockedFileName(file.name)) {
            return
        }

        return uploadFile(file, file.uploadUrl, onProgress, false, '')
            .then(onSuccess)
            .catch(onError)
    }

    markUploadedEntity = file => {
        message.success(`${file.name} uploaded correctly`)
    }

    onSuccess = file => {
        const { onSuccess } = this.props

        return onSuccess(file)
    }

    onError = error => {
        message.error(error || 'Failed to upload.')
    }

    render() {
        const { dropzone, className } = this.props

        let isDropzone = false

        if (dropzone) {
            isDropzone = true
        }
        return (
            <Box alignItems="center" flex>
                <FileUploader
                    placement={UPLOADER_PLACEMENT}
                    onFileDropped={this.createEntity}
                    onUpload={this.uploadEntity}
                    dropzone={isDropzone}
                    className={className}
                    onUploadSuccess={this.markUploadedEntity}
                    onSuccess={this.onSuccess}
                    onError={this.onError}
                    showUploadList={false}
                    buttonType="primary"
                    multiple
                >
                    {this.props.children}
                </FileUploader>
            </Box>
        )
    }
}

export default _.flowRight(connect())(UploadMessageAttachment)
